import {checkbox, required} from "./field-rules";
import { password } from "./field-icons";

export default [
  {
    name: "username",
    attrs: {
      type: "text",
      label: "Логин",
      required: true
    },
    rules: [required]
  },
  {
    name: "password",
    attrs: {
      type: "password",
      label: "Пароль",
      required: true,
      appendIcons: password
    },
    rules: [required]
  },
  {
    name: "allowConsent",
    attrs: {
      type: "checkbox",
      label: "Я даю согласие на обработку персональных данных",
      required: true
    },
    rules: [checkbox]
  }
];
